import { Box } from "@mui/material";
const myGif = '/solin-loading.gif';

const Loading = () => {
    return (
        <Box
            sx={{
                alignItems: 'center',
                display: 'flex',
                inset: 0,
                justifyContent: 'center',
                position: 'fixed',
                zIndex: theme => theme.zIndex.modal,
            }}
        >
            <Box component="img" sx={{ width: 250, height: 'auto' }} src={myGif} alt="Loading..." />
        </Box>
    )
}

export default Loading
